const CollectionLifeCycle = {
  componentDidMount() {
    const { fetchPlayerInformationsWithMap, fetchCardsList } = this.props;

    fetchCardsList();
    fetchPlayerInformationsWithMap();
  },
}

export default CollectionLifeCycle;